import { createReducer, on } from '@ngrx/store';
import { loadSummarySuccess } from './actions';
import { initialState } from './initial-state';

export const assetSummaryReducer = createReducer(
  initialState,
  on(loadSummarySuccess, (_, action) => action.summary),
);
